/** Who did something. Used by audit rows, domain events, RPC calls and approvals. */
import { z } from 'zod';
import { ActorKind, Via } from './enums.ts';
import { StaffId, UserId, ViewSessionId } from './ids.ts';

export const Actor = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('user'), id: UserId }),
  z.object({ kind: z.literal('staff'), id: StaffId, viewSessionId: ViewSessionId.optional() }),
  z.object({ kind: z.literal('system'), id: z.string().regex(/^[a-z][a-z0-9_.:-]{1,63}$/).meta({ examples: ['job:publish'] }) }),
  z.object({ kind: z.literal('agent'), id: z.string().regex(/^[a-z][a-z0-9_.:-]{1,63}$/).meta({ examples: ['agent:change-request'] }) }),
  z.object({ kind: z.literal('mcp'), id: StaffId }),
  z.object({ kind: z.literal('webhook'), id: z.enum(['stripe', 'twilio', 'google', 'jobber', 'housecall_pro', 'sequencer', 'inbound_email']) }),
]);
export type Actor = z.infer<typeof Actor>;

// Compile-time guard: the union's kinds equal the DB list (audit_events.actor_kind), both ways.
type Kinds = z.infer<typeof ActorKind>;
type SameKinds = [Actor['kind']] extends [Kinds] ? ([Kinds] extends [Actor['kind']] ? true : false) : false;
export const ACTOR_KINDS_MATCH_DB: SameKinds = true;

export { Via };
